import { PHOTO_BUTTON_HIDDEN, PHOTO_BUTTON_DISABLED } from "../constants"

class ButtonElement {
  constructor(element, direction) {
    this.element = element
    this.direction = direction
    this._onClickCallbackList = []

    this.element.addEventListener("click", (event) => {
      event.preventDefault()
      this._onClickCallbackList.forEach((callback) => callback(this.direction))
    })
  }

  onClick(callback) {
    this._onClickCallbackList.push(callback)
  }

  toggleVisibility(shouldBeHidden) {
    this.element.classList.toggle(PHOTO_BUTTON_HIDDEN, shouldBeHidden)
  }

  toggleDisableState(shouldBeDisabled) {
    this.element.classList.toggle(PHOTO_BUTTON_DISABLED, shouldBeDisabled)
  }
}

export default ButtonElement
